import { Card, Input, Select, Row, Col, Button } from "antd";
import { useDispatch } from "react-redux";
import { fetchLeads } from "../leadThunk";
import { useEffect, useState } from "react";
import axios from "axios";

const LeadFilters = () => {
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    search: "",
    source: null,
  });

  const [customFields, setCustomFields] = useState([]);

  // 🔥 Fetch custom fields
  useEffect(() => {
    const loadFields = async () => {
      try {
        const res = await axios.get("/crm/settings/fields");
        setCustomFields(res.data || []);
      } catch (err) {
        console.log("field fetch error", err);
      }
    };
    loadFields();
  }, []);

  const handleSearch = () => {
    dispatch(fetchLeads(filters));
  };

  return (
    <Card className="mb-4">
      <Row gutter={[16, 16]}>

        {/* SEARCH */}
        <Col span={8}>
          <Input
            placeholder="Search name / phone"
            onChange={(e) =>
              setFilters((s) => ({
                ...s,
                search: e.target.value,
              }))
            }
          />
        </Col>

        {/* SOURCE */}
        <Col span={6}>
          <Select
            placeholder="Source"
            style={{ width: "100%" }}
            onChange={(v) =>
              setFilters((s) => ({
                ...s,
                source: v,
              }))
            }
            options={[
              { label: "All", value: null },
              { label: "Inquiry", value: "inquiry" },
              { label: "Manual", value: "account" },
            ]}
          />
        </Col>

        {/* 🔥 CUSTOM FILTERS */}
        {customFields
          .filter((f) => f.show_in_filter)
          .map((field) => (
            <Col span={6} key={field.id}>
              {field.type === "dropdown" ? (
                <Select
                  placeholder={field.field_name}
                  style={{ width: "100%" }}
                  options={(field.options || []).map((o) => ({
                    label: o.value,
                    value: o.value,
                  }))}
                  onChange={(v) =>
                    setFilters((s) => ({
                      ...s,
                      [field.field_key]: v,
                    }))
                  }
                />
              ) : (
                <Input
                  placeholder={field.field_name}
                  onChange={(e) =>
                    setFilters((s) => ({
                      ...s,
                      [field.field_key]: e.target.value,
                    }))
                  }
                />
              )}
            </Col>
          ))}

        {/* BUTTON */}
        <Col span={4}>
          <Button type="primary" block onClick={handleSearch}>
            Search
          </Button>
        </Col>

      </Row>
    </Card>
  );
};

export default LeadFilters;